import React from 'react'
import PropTypes from 'prop-types'
import ClassNames from 'classnames'
import { SelectStyle } from './styled'
import { default as ReactSelect } from 'react-select'
import { consolidateStreamedStyles } from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

const SelectBoxCategoryUser = props => {
  const { className, fieldValue, isErrCategory } = props
  const selectAll = [{ label: 'Select all', value: 'All' }]
  const selectNotAll = []
  if (typeof fieldValue !== 'undefined' && fieldValue) {
    if (fieldValue.length === props.options.length) {
      Array.prototype.push.apply(selectAll, fieldValue)
    } else {
      Array.prototype.push.apply(selectNotAll, fieldValue)
    }
  }
  const checkSelectAll =
    typeof fieldValue !== 'undefined' &&
    fieldValue &&
    fieldValue.length === props.options.length
  const customStyles = {
    placeholder: base => ({
      ...base,
      color: VARIABLES.COLORS.GRAY_3,
    }),

    singleValue: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.GRAY_3,
      outline: 'none',
    }),

    control: (base, { isDisabled }) => ({
      ...base,
      whiteSpace: 'nowrap',
      boxShadow: 'none',
      // borderColor: VARIABLES.COLORS.GRAY_2,
      borderColor: isErrCategory
        ? VARIABLES.COLORS.RED_1
        : VARIABLES.COLORS.GRAY_2,
      '&:hover': {
        borderColor: isErrCategory
          ? VARIABLES.COLORS.RED_1
          : VARIABLES.COLORS.GRAY_2,
      },
      backgroundColor: isDisabled ? VARIABLES.COLORS.GRAY_8 : undefined,
      height: '100%',
      '@media only screen and (min-width: 1601px)': {
        ...base['@media only screen and (min-width: 1601px)'],
        minWidth: '150px',
      },
    }),
    menuList: base => ({
      ...base,
      color: VARIABLES.COLORS.BLUE_1,
    }),
    indicatorSeparator: base => ({
      ...base,
      display: 'none',
      width: '0px',
    }),

    dropdownIndicator: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.BLUE_1,
      '&:hover': {
        color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.BLUE_1,
      },
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    clearIndicator: base => ({
      ...base,
      display: 'none',
      padding: '0',
    }),
    option: (style, { isSelected }) => ({
      ...style,
      label: {
        color: isSelected ? `${VARIABLES.COLORS.WHITE} !important` : undefined,
      },
    }),
  }
  if (props.allowSelectAll) {
    return (
      <SelectStyle className={ClassNames('select-control')}>
        <ReactSelect
          {...props}
          noOptionsMessage={() => "Can't find Category"}
          placeholder="Select Category"
          styles={customStyles}
          options={[props.allOption, ...props.options]}
          value={checkSelectAll ? selectAll : selectNotAll}
          onChange={(selected, event) => {
            if (selected !== null && selected.length > 0) {
              let result = []
              if (event.action === 'select-option') {
                if (
                  selected[selected.length - 1].value ===
                    props.allOption.value ||
                  selected.length === props.options.length
                ) {
                  return props.onChange([props.allOption, ...props.options])
                }
                return props.onChange(selected)
              } else if (
                event.action === 'remove-value' &&
                event.removedValue.value !== 'All'
              ) {
                result = selected.filter(
                  option => option.value !== event.removedValue.value
                )
              } else if (
                event.action === 'deselect-option' &&
                event.option.value !== 'All'
              ) {
                result = selected.filter(
                  option => option.value !== props.allOption.value
                )
              }
              return props.onChange(result)
            }
            return props.onChange(selected)
          }}
        />
      </SelectStyle>
    )
  }

  return (
    <SelectStyle className={ClassNames('select-control', className)}>
      <ReactSelect {...props} />
    </SelectStyle>
  )
}

SelectBoxCategoryUser.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
}

SelectBoxCategoryUser.defaultProps = {
  allOption: {
    label: 'Select all',
    value: 'All',
  },
  className: '',
}

export default SelectBoxCategoryUser
